import { isVideoPost, VideoType } from '../../helpers/domain/videoTypes';
import {
  getMainCategory,
  PostSubcategory,
} from '../../helpers/domain/postCategories';

export type ArticleTypeInGA =
  | 'videos'
  | 'project_review'
  | 'project_preview'
  | 'point_of_view'
  | 'location_insight'
  | 'guides'
  | 'news'
  | 'decor';

export function getArticleTypeInGA(
  category: PostSubcategory,
  videoType: VideoType,
): ArticleTypeInGA {
  if (isVideoPost(videoType)) return 'videos';
  const mainCategory = getMainCategory(category);
  return mainCategory === 'project_research'
    ? (category as ArticleTypeInGA)
    : (mainCategory as ArticleTypeInGA);
}
